import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { formatNumber } from '../../../../CommonUtils/formatNumber';

export const nullableMortgageTypeSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphData => get(graphData, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.MortgageType`, null),
);

export const hasMortgageSelector = createSelector(
  nullableMortgageTypeSelector,
  nullableMortgageType => nullableMortgageType !== null,
);

export const mortgageTypeOptionsOrDefaultSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty => get(graphDataOrEmpty, 'MortgageTypeOptions', []),
);

export const selectedMortgageOptionOrDefaultSelector = createSelector(
  mortgageTypeOptionsOrDefaultSelector,
  nullableMortgageTypeSelector,
  (options, nullableMortgageType) =>
    options.find(({ value }) => value === nullableMortgageType) || {
      label: '',
      value: null,
    },
);

export const nullableMortgageInterestRateSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphData => {
    const interestRate = get(graphData, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.InterestRate`, null);
    if (interestRate !== null) {
      return Math.round(interestRate * 1000) / 1000;
    }
    return null;
  },
);

export const nullableMortgagePMISelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphData => {
    const pmi = get(graphData, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Pmi`, null);
    if (pmi !== null) {
      return Math.round(pmi * 100) / 100;
    }
    return null;
  },
);

export const mortgageDetailsOrDefaultSelector = createSelector(
  selectedMortgageOptionOrDefaultSelector,
  nullableMortgageInterestRateSelector,
  (selectedMortgageOptionOrDefault, nullableInterest) => {
    if (nullableInterest !== null && selectedMortgageOptionOrDefault.value !== null) {
      return `${selectedMortgageOptionOrDefault.label}, ${formatNumber(nullableInterest, {
        decimalPlaces: 3,
      })}%`;
    }
    return '-';
  },
);
